/**
 * JM Theme Mode – Light / Dark / High-Contrast / Sepia
 * Manages theme switching, localStorage persistence, and
 * prefers-color-scheme auto-detection.
 */
(function () {
  'use strict';

  if (window.__jmThemeModeInitialized) return;
  window.__jmThemeModeInitialized = true;

  var STORAGE_KEY = 'jm-theme';
  var MODES = ['light', 'dark', 'high-contrast', 'sepia'];
  var html = document.documentElement;
  var mediaQueryList = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  /* ---- helpers ---------------------------------------- */
  function getSystemPref() {
    if (mediaQueryList && mediaQueryList.matches) {
      return 'dark';
    }
    return 'light';
  }

  function getSaved() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function save(mode) {
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) { /* silent */ }
  }

  function apply(mode) {
    if (MODES.indexOf(mode) === -1) mode = 'light';
    html.setAttribute('data-theme', mode);
    updateToggles(mode);
  }

  /* ---- toggle UI updates ----------------------------- */
  function updateToggles(mode) {
    var options = document.querySelectorAll('.jm-tm__option');
    options.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-mode') === mode);
    });
  }

  /* ---- init ------------------------------------------ */
  function init() {
    var saved = getSaved();
    var defaultMode = html.getAttribute('data-theme-default') || 'auto';

    if (saved && MODES.indexOf(saved) !== -1) {
      apply(saved);
    } else if (defaultMode === 'auto') {
      apply(getSystemPref());
    } else {
      apply(defaultMode);
    }

    /* System preference listener (only when no explicit save) */
    if (mediaQueryList) {
      mediaQueryList.addEventListener('change', function (e) {
        if (!getSaved()) {
          apply(e.matches ? 'dark' : 'light');
        }
      });
    }

    bindToggles();
  }

  /* ---- toggle button bindings ------------------------ */
  function bindToggles() {
    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('.jm-tm__btn');
      if (toggleBtn) {
        e.stopPropagation();
        var toggleRoot = toggleBtn.closest('.jm-tm');
        if (!toggleRoot) return;
        var panel = toggleRoot.querySelector('.jm-tm__panel');
        if (!panel) return;
        var isOpen = panel.classList.contains('is-open');
        closeAllPanels();
        if (!isOpen) panel.classList.add('is-open');
        return;
      }

      var optionBtn = e.target.closest('.jm-tm__option');
      if (optionBtn) {
        var mode = optionBtn.getAttribute('data-mode');
        if (!mode) return;
        apply(mode);
        save(mode);
        closeAllPanels();
        return;
      }

      if (!e.target.closest('.jm-tm')) {
        closeAllPanels();
      }
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });
  }

  function closeAllPanels() {
    document.querySelectorAll('.jm-tm__panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
  }

  /* ---- boot ------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
